import UnitForm from '@/components/admin/units/UnitForm';
import ComponentGuard from '@/components/ui/custom/ComponentGuard';
import { UserTypeEnum } from '@/models/User';
import { accordion } from '@/utils/animations/commom';
import { AnimatePresence, motion } from 'motion/react';
import { twJoin } from 'tailwind-merge';

type Props = {
  show?: boolean;
  setShow: (show: boolean) => void;
};

export default function AddUnit(props: Props) {
  const { show, setShow } = props;

  return (
    <ComponentGuard roles={[UserTypeEnum.SUPER_ADMIN]}>
      <AnimatePresence>
        {show && (
          <motion.div
            className={twJoin(
              'flex justify-end',
              'w-full',
              show ? '' : 'overflow-hidden',
            )}
            {...accordion}
          >
            <UnitForm onCancel={() => setShow(false)} formMode="create" />
          </motion.div>
        )}
      </AnimatePresence>
    </ComponentGuard>
  );
}
